<template>
  <section v-if="completedApi && courseLiveData.length > 0" class="pb-0">

    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="live-class-section">
            <Carousel3d v-if="isDesktop && courseLiveData.length > 0"
                        :controls-visible="true"
                        dir="rtl" display="3"
                        inverse-scaling="200"
                        space="280"
                        width="1100"
                        height="620"
                        border="0"
                        perspective="0"
                        class="carousel-live-class-slider">
              <Slide v-for="(liveCourse,i) in [...courseLiveData]" :key="'3d-carousal-'+i" :index="i">
                <div class="card-live_class">
                  <img fetchpriority="high" alt="bg-video" src="../../assets/images/background/liveclass-back.webp"
                       class="card-bg" loading="lazy"/>
                  <div class="header">
                    <i class="icon-play-live"></i>
                    <span style="margin-left: 5px">کلاس زنده</span>
                    <span v-if="liveCourse.is_free"> و رایگان</span>
                  </div>

                  <div class="course-title">
                    <p class="">{{ liveCourse.parent_name }} {{ liveCourse.name }}</p>

                  </div>
                  <div class="row">
                    <div class="col-md-7">
                      <div class="video-box">
                        <div v-if="beforeLoadingVideo" class="text-content">
                          در حال بارگذاری کلاس
                          <div class="spinner-border" role="status"></div>
                        </div>
                        <PlyrJsVideoPlayer v-if="activeVideoBox && (this.checkVideoType(liveCourse.record_video_kavimo) === 'm3u8' ||this.checkVideoType(liveCourse.record_video_kavimo) ==='wlproxy')"
                                       :vodLink="liveCourse.record_video_kavimo"></PlyrJsVideoPlayer>
                        <div class="video" v-if="activeVideoBox && this.checkVideoType(liveCourse.record_video_kavimo) ==='default'"
                             v-html="liveCourse.record_video_kavimo"></div>

                        <span class="text-content" v-if="classinoConnectAlert && !activeVideoBox">برای مشاهده کلاس وارد شوید. 👈</span>

                      </div>
                    </div>
                    <div class="col-md-5">
                      <div class="content-box">
                        <i class="icon-attention"></i>

                        <div v-if="liveCourse.show_cc_btn">
                          <p>برای استفاده از تمامی امکانات کلاس</p>
                          <p>زنده وارد پنل خود و نرم افزار کلاسینو کانکت شوید</p>
                        </div>
                        <h3 class="h-title mt-3" v-if="!liveCourse.show_cc_btn && !liveCourse.show_class_btn">پخش زنده
                          کلاسینو</h3>
                        <h6 class="h-text">{{ liveCourse.description }}</h6>

                        <a v-if="liveCourse.show_cc_btn"
                           :href="siteUrl + '/redirectAfterLogin/live_stream/' + liveCourse.class_id"
                           class="btn cl-btn cl-btn-orange w-mobile-100 flex-column">
                          <div>
                            <span>ورود به کلاس </span>
                            <span v-if="liveCourse.is_free">رایگان</span>
                          </div>
                          <div>
                            Classino Connect
                          </div>
                        </a>
                        <a v-if="liveCourse.show_class_btn"
                           :href="siteUrl + '/redirectAfterLogin/class/' + liveCourse.class_id"
                           class="btn cl-btn cl-btn-pink mt-3 w-mobile-100">ارسال تکلیف و آزمون</a>
                      </div>
                    </div>
                    <div v-if="classinoConnectAlert" class="col-md-12 mt-4">
                        <span class="alert alert-danger">
                               <i class="icon-attention"></i>
                          کلاس تا دقایقی دیگر قطع میشود. برای مشاهده کلاس و استفاده از تمامی امکانات وارد شوید.
                        </span>
                    </div>
                  </div>
                </div>
              </Slide>
            </Carousel3d>
            <!--            <slick v-else :options="slickOptions" class="slick-carousel slick-live-class-slider">-->
            <!--              -->
            <!--            </slick>-->
            <v-carousel v-else height="auto" hide-delimiter-background
                        :show-arrows="$vuetify.display.lgAndUp && courseLiveData.length > 1" hide-delimiters
                        class="slick-live-class-slider">
              <v-carousel-item v-for="(liveCourse,i)  in courseLiveData" :key="i" class="card-live_class">
                <div class="card-live_class">
                  <div class="header">
                    <i class="icon-play-live"></i>
                    <span style="margin-left: 5px">کلاس زنده</span>
                    <span v-if="liveCourse.is_free">و رایگان</span>
                  </div>

                  <div class="course-title">
                    <p class="">{{ liveCourse.parent_name }} {{ liveCourse.name }}</p>
                    <span class="">{{ liveCourse.description }}</span>
                  </div>
                  <div class="row">
                    <div class="col-md-7">
                      <div class="video-box">
                        <div v-if="beforeLoadingVideo" class="text-content">
                          در حال بارگذاری کلاس
                          <div class="spinner-border" role="status"></div>
                        </div>
                        <PlyrJsVideoPlayer v-if="activeVideoBox && (this.checkVideoType(liveCourse.record_video_kavimo) === 'm3u8' ||this.checkVideoType(liveCourse.record_video_kavimo) === 'wlproxy')"
                                       :vodLink="liveCourse.record_video_kavimo"></PlyrJsVideoPlayer>
                        <div class="video" v-if="activeVideoBox && this.checkVideoType(liveCourse.record_video_kavimo) ==='default'"
                             v-html="liveCourse.record_video_kavimo"></div>
                        <!--                        <p v-if="liveCourse.record_video_kavimo">ویدیو مشکل دارد</p>-->
                        <p class="text-content" v-if="classinoConnectAlert && !activeVideoBox">برای مشاهده کلاس وارد
                          شوید. 👈</p>
                      </div>
                    </div>
                    <div class="col-md-5">
                      <div class="content-box">
                        <i class="icon-attention"></i>
                        <div v-if="liveCourse.show_cc_btn">
                          <p>برای استفاده از تمامی امکانات کلاس</p>
                          <p>زنده وارد نرم افزار کلاسینو کانکت شوید</p>
                        </div>
                        <h3 class="mt-3" v-if="!liveCourse.show_cc_btn && !liveCourse.show_class_btn">پخش زنده
                          کلاسینو</h3>
                        <a v-if="liveCourse.show_cc_btn"
                           :href="siteUrl + '/redirectAfterLogin/live_stream/' + liveCourse.class_id"
                           class="btn cl-btn cl-btn-orange w-mobile-100">ورود به کلاس رایگان<br>Classino Connect</a>
                        <a v-if="liveCourse.show_class_btn"
                           alt="btn-enter"
                           :href="siteUrl + '/redirectAfterLogin/class/' + liveCourse.class_id"
                           class="btn cl-btn cl-btn-pink mt-3 w-mobile-100">ارسال تکلیف و آزمون</a>
                      </div>
                    </div>
                    <div v-if="classinoConnectAlert" class="col-md-12 mt-4">

                            <span class="alert alert-danger">
                                   <i class="icon-attention"></i>
                              کلاس تا دقایقی دیگر قطع میشود. برای مشاهده کلاس و استفاده از تمامی امکانات وارد شوید.
                            </span>
                    </div>
                  </div>

                </div>
              </v-carousel-item>
            </v-carousel>

          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import axios from 'axios';
import PlyrJsVideoPlayer from "@/components/video/PlyrJsVideoPlayer.vue";
import {Carousel3d, Slide} from 'vue3-carousel-3d';
import "vue3-carousel-3d/dist/index.css"

export default {

  components: {Carousel3d, Slide, PlyrJsVideoPlayer},
  data() {
    return {
      courseLiveData: '',
      completedApi: false,
      externalData: [],
      slickOptions: {
        rtl: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        // lazyLoad: 'onDemand',
      },
      beforeLoadingVideo: true,
      classinoConnectAlert: false,
      activeVideoBox: true,
      videoType: '',
      siteUrl: this.$nxBaseUrl
    }
  },
  computed: {
    isDesktop() {
      return this.$vuetify.display.lgAndUp;
    }
  },
  mounted() {
    // Offline carousel test data
    // this.courseLiveData = [
    //   {
    //     class_id: 123,
    //     name: "آزمون در صفحه دوره",
    //     parent_name: "آزمایشی",
    //     description: "آزمون در صفحه دوره آزمون در صفحه دوره آزمون در صفحه دوره آزمون در صفحه دوره آزمون در صفحه دوره آزمون در صفحه دوره",
    //     img: "",
    //     is_free: true,
    //     show_cc_btn: false,
    //     record_video_kavimo: "https://wlproxy.classino.com/redirect/live_so/smil:myStream.smil?type=m3u8",
    //     record_video_kavimo_HD: "https://wlproxy.classino.com/redirect/live_so/smil:myStream.smil?type=m3u8",
    //     show_class_btn: false
    //   }
    // ];

    axios.get('https://landing.classino.com/static_free_player_config/index.php').then(responsive => {
    // axios.get('http://127.0.0.1:8000/index.php').then(responsive => {
      this.externalData = responsive.data
      console.log(responsive.data )
      if (this.externalData.length) {
        this.courseLiveData = this.externalData;
        this.completedApi = true;

      } else {

        axios.get(this.$baseUrl + '/course/freeLiveClasses').then(response => {
          this.courseLiveData = response.data;
          this.completedApi = true;
          this.timeoutActions()
        }).catch(error => {
          console.log(error.response.data)
        });
      }
    }).catch(error => {
      console.log(error)
    });

    setTimeout(() => {
      this.beforeLoadingVideo = false
    }, 5000)
  },
  methods: {
    checkVideoType(videoUrl) {

      if (videoUrl) {
        if (videoUrl.endsWith('.m3u8')) {
          return 'm3u8';
        } else if (videoUrl.includes('wlproxy')) {
          return 'wlproxy'
        } else {
          // alert(videoUrl)
          return 'default'
        }
      }
      // alert(this.videoType)

    },
    is_m3u8(videoURL) {
      return videoURL.endsWith('.m3u8');
    },
    timeoutActions() {
      setTimeout(() => {
        this.classinoConnectAlert = true
        setTimeout(() => {
          this.activeVideoBox = false
        }, 60000)
      }, 240000)
    }
  }

}
</script>
<style lang="scss">
.live-class-section {
  .card-live_class {
    position: relative;
    background: linear-gradient(180deg, rgba(20, 136, 204, 1) 0%, rgba(43, 50, 178, 1) 100%);
    border-radius: 20px;
    margin-top: 2rem;
    text-align: center;
    display: block;
    padding: 0 30px 30px;
    @include media-breakpoint-down(md) {
      padding: 0 15px 15px;
    }

    .header {
      padding: 10px 20px;
      border-radius: 100px;
      border: solid 2px #ffaf20;
      background-color: #fff9ef;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      font-size: 1.4rem;
      font-weight: 800;
      color: #ffaf20;
      margin: -2rem 0 2rem;
      @include media-breakpoint-down(md) {
        font-size: 1.2rem;
        font-weight: 800;
        padding: 5px 15px;
        margin: -1rem 0 1rem;
      }

      i {
        margin-left: 10px;
        font-size: 2.3rem;
        font-weight: 700;
        @include media-breakpoint-down(md) {
          font-size: 1.5rem;
        }
      }
    }

    .course-title {
      display: flex;
      justify-content: space-between;
      @include media-breakpoint-down(md) {
        flex-direction: column;
      }

      p {
        font-size: 1.4rem;
        font-weight: 800;
        color: #efefef;
        @include media-breakpoint-down(md) {
          font-size: 1.1rem;
          padding-bottom: unset;
        }
      }

      span {
        width: 40%;
        @include media-breakpoint-down(md) {
          width: 100%;
          text-align: center;
          padding-bottom: 30px;

        }
        text-align: right;
        padding-bottom: 10px;
      }
    }

    .content-box {
      backdrop-filter: blur(12.5px);
      background-color: rgba(255, 255, 255, 0.25);
      border-radius: 7px;
      padding: 15px;
      color: #efefef;
      font-size: 1.2rem;
      font-weight: 800;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      @include media-breakpoint-down(md) {
        font-size: 1rem;
      }

      p:nth-of-type(1) {
        margin-top: 1rem;
      }

      a {
        height: 70px;
        border-radius: 10px;
        font-weight: 800;
        @include media-breakpoint-down(md) {
          margin-top: 0;
          font-size: 1rem;
          height: 60px;
        }
      }

      i {
        color: #ffaf20;
        font-size: 3rem;
        //margin-bottom: 2rem;
        @include media-breakpoint-down(md) {
          font-size: 2rem;
        }
      }
    }

    .alert-danger {
      display: flex;
      align-items: center;
      margin-bottom: 0;
      justify-content: center;
      font-weight: 700;
      @include media-breakpoint-down(md) {
        font-size: .8rem;
        text-align: right;
      }

      i {
        margin-left: 1rem;
        font-size: 1.5rem;
      }
    }
  }

  .video-box {
    position: relative;
    width: 100%;
    height: 100%;
    max-height: 100%;
    @include media-breakpoint-down(md) {
      margin-bottom: 2rem;
      height: 180px;
    }

    .video {
      z-index: 2;
    }

    iframe {
      border-radius: 10px;
      border: none;
    }
  }

}

.carousel-live-class-slider {
  .card-bg {
    position: absolute;
    background-size: cover;
    width: 100%;
    display: block;
    left: -25%;
  }

  .card-live_class {
    &:before {
      content: ' ';
      background: url("~@/assets/image/background/liveclass-back.webp") no-repeat;
      background-size: cover;
      width: 100%;
      height: 100%;
      position: absolute;
      display: block;
      left: -25%;
      @include media-breakpoint-down(lg) {
        background: unset;
      }
    }

    .text-content {
      position: absolute;
      top: 40%;
      left: 30%;
      color: whitesmoke;
      font-size: 1.2rem;
      font-weight: 700;
    }
  }

  .carousel-3d-slide {
    background: none;
  }

  .carousel-3d-slide:not(.current) {
    opacity: .7 !important;
  }

  .carousel-3d-controls {
    a {
      display: flex;
      align-items: center;
      justify-content: center;

      &:before {
        position: absolute;
        font-family: 'icomoon' !important;
        -webkit-font-smoothing: antialiased;
        font-size: 2.3rem !important;
        color: #989898 !important;
        line-height: 0;

      }

      span {
        display: none;
      }
    }

    .prev {
      left: unset;
      right: 20px;

      &:before {
        content: "\e904";
      }
    }

    .next {
      right: unset;
      left: 20px;

      &:before {
        content: "\e903";
      }
    }
  }

}

.slick-live-class-slider {
  .video-box {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    .video {
      width: 100%;
    }
  }

  .text-content {
    color: whitesmoke;
    font-size: 1.2rem;
    font-weight: 700;
  }

  .slick-slide {
    margin: 0 20px;
  }

  .slick-next:before, .slick-prev:before {
    opacity: 1;
  }

  .slick-prev {
    @include media-breakpoint-down(md) {
      right: -15px !important;
    }
  }

  .slick-next {
    @include media-breakpoint-down(md) {
      left: -15px !important;
    }
  }
}


.h-title {
  text-align: center;
  font-weight: 800;
  margin-top: 1rem;
  color: white;
}

.h-text {
  text-align: justify;
  margin-top: 1rem;
  line-height: 1.5rem
}

</style>
